import { render, staticRenderFns } from "./SubjectPage.vue?vue&type=template&id=b84b2a5c&scoped=true"
import script from "./SubjectPage.vue?vue&type=script&lang=js"
export * from "./SubjectPage.vue?vue&type=script&lang=js"
import style0 from "./SubjectPage.vue?vue&type=style&index=0&id=b84b2a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84b2a5c",
  null
  
)

export default component.exports